import React, { useState } from 'react';
import Label from '../../components/common/Label';
import Input from '../../components/common/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { passwordValidationsMessages } from '../../constants/index';
import ValidationIcon from '../../components/common/ValidateIcon';

const PasswordInput = ({ handlePasswordChange, password, passwordValidation }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  return (
    <>
      <div className="relative min-h-[2rem] mb-0">
        <Label variant="dark" htmlFor="password" customClass="block text-sm font-normal">
          New Password
        </Label>
        <Input
          variant="tertiary"
          type={passwordVisible ? 'text' : 'password'}
          id="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="Enter your Password"
          ariaLabel="Password input field"
          ariaDescribedby="password-error"
        />
        <button
          type="button"
          onClick={() => setPasswordVisible(!passwordVisible)}
          aria-label={passwordVisible ? 'Hide password' : 'Show password'}
          className="absolute right-3 bottom-2 bg-none border-none cursor-pointer w-auto"
        >
          <FontAwesomeIcon
            icon={passwordVisible ? faEyeSlash : faEye}
            className="text-lg text-gray-500"
          />
        </button>
      </div>
      <ul className="mt-2">
        {Object.keys(passwordValidation).map((key) => {
          const isValid = passwordValidation[key];
          const textColorClass = isValid ? 'text-custom-success-color' : 'text-gray-500';
          return (
            <li key={key} className={`flex items-center text-[15px] ${textColorClass}`}>
              <span className="flex items-center mr-2">
                <ValidationIcon isValid={isValid} />
              </span>
              {passwordValidationsMessages[key]}
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default PasswordInput;
